"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cancellable = void 0;
exports.setTimeoutCancellable = setTimeoutCancellable;
/** Idempotent cancellable implementation */
class Cancellable {
    callback;
    _cancelled = false;
    constructor(callback) {
        this.callback = callback;
    }
    cancel = () => {
        if (this._cancelled)
            return;
        this._cancelled = true;
        const callback = this.callback;
        this.callback = undefined;
        callback?.();
    };
    get isCancelled() {
        return this._cancelled;
    }
}
exports.Cancellable = Cancellable;
/**
 * Sets a timeout that can be cancelled by disposing the returned cancellable
 * The handler function will not be invoked if the returned cancellable is cancelled first
 */
function setTimeoutCancellable(handler, ms) {
    const handle = setTimeout(handler, ms);
    return new Cancellable(() => {
        clearTimeout(handle);
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FuY2VsbGFibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvY2FuY2VsbGFibGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBMkJBLHNEQUtDO0FBaENELDRDQUE0QztBQUM1QyxNQUFhLFdBQVc7SUFDZCxRQUFRLENBQWM7SUFDdEIsVUFBVSxHQUFHLEtBQUssQ0FBQztJQUUzQixZQUFZLFFBQWtDO1FBQzVDLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO0lBQzNCLENBQUM7SUFFRCxNQUFNLEdBQUcsR0FBUyxFQUFFO1FBQ2xCLElBQUksSUFBSSxDQUFDLFVBQVU7WUFBRSxPQUFPO1FBQzVCLElBQUksQ0FBQyxVQUFVLEdBQUcsSUFBSSxDQUFDO1FBRXZCLE1BQU0sUUFBUSxHQUFHLElBQUksQ0FBQyxRQUFRLENBQUM7UUFDL0IsSUFBSSxDQUFDLFFBQVEsR0FBRyxTQUFTLENBQUM7UUFDMUIsUUFBUSxFQUFFLEVBQUUsQ0FBQztJQUNmLENBQUMsQ0FBQztJQUVGLElBQUksV0FBVztRQUNiLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUN6QixDQUFDO0NBQ0Y7QUFwQkQsa0NBb0JDO0FBRUQ7OztHQUdHO0FBQ0gsU0FBZ0IscUJBQXFCLENBQUMsT0FBbUIsRUFBRSxFQUFVO0lBQ25FLE1BQU0sTUFBTSxHQUFHLFVBQVUsQ0FBQyxPQUFPLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdkMsT0FBTyxJQUFJLFdBQVcsQ0FBQyxHQUFHLEVBQUU7UUFDMUIsWUFBWSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3ZCLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQyJ9